import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  getProcessInstances,
  submitConsent,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter, TabsTimelineSub, Modal } from 'components';
import { isNil , isNull } from 'lodash';
import { checkUser, checkUserLogged, getUser , getTaxisData} from 'store/user/actions';
import { getMainformDetails } from 'store/forms/actions';
import { stepsBeneficiary } from './stepsBeneficiary';
import { stepsAuditor } from './stepsAuditor';
import { stepsObjection } from './stepsObjection';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary, isAuditor, isObjectionCommittee, isMinistry } from '../../../utils';
import { ValidationBanner } from 'components/layout/components';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';

import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';
import { stepsObjectionEvaluation } from './stepsObjectionEvaluation';
import { stepsObjectionManual } from './stepsObjectionManual';


const MainForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  // const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const user = useSelector(state => state.user);
  const privileges = useSelector(state => state.user.privileges);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const carrier = useSelector(state => state.forms.carrier);
  const activeFormId = useSelector(state => state?.activeForm?.activeFormId);
  const formId = useSelector(state => state?.forms?.formId);
  const forms = useSelector(state => state.forms);
  const loadingPage = useSelector(state=>state.user.loading);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const consent = useSelector(state => state.forms.audit.consent);
  const consentByCommittee = useSelector(state => state.forms.objCommittee.consentByCommittee);
  const commentObjCommittee = useSelector(state => state.forms.objCommittee.commentObjCommittee);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);

  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(getFormData(params.taskId));
    // dispatch(getFormUploads(params.taskId));
    if(window.location.pathname.includes('view')){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true
           
        })
      );
    }
  }, [dispatch, params.taskId]);

  useEffect(() => {
    if(viewMode || (( activeTaskName && activeTaskName !== "task.name.application_submission"))){
      dispatch(getMainformDetails(task?.processInstanceId));
    }
  }, [task?.processInstanceId, activeTaskName]);

  useEffect(()=>{
    if(!isNil(loadingPage)){
      setLoadingPageVar(loadingPage);
    }
  },[loadingPage]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  //RENDER FORMS function based on user and task
  const steps = useMemo(() => {
    if (!activeTaskName || !user?.groups) {
      return []; // safe fallback while waiting
    }

    if(activeTaskName && user?.groups){
    if(isBeneficiary(user?.groups) || isMinistry(user?.groups)){
      if(activeTaskName === 'task.name.accepted'){
          return consentByCommittee ? stepsObjectionEvaluation : stepsAuditor;
      }else if(activeTaskName === "task.name.application_evaluation_by_committee"){ //GBAT-68: Beneficiary will be able to see the ObjectionEvaluationFormAuditor tab even if is in progress
          return stepsObjectionEvaluation;
      }
      else if(activeTaskName === 'task.name.final_rejected'){
          return stepsObjectionEvaluation;
      }
      else if((activeTaskName === "task.name.application_evaluation_by_auditor" || activeTaskName === "task.name.application_evaluation") && commentObjCommittee){ //GBAT-80: Beneficiay will be able to see the stepsObjectionEvaluation tab even if is in status of application_evaluation_by_auditor but only if the objection committee has entered comment(THATS WHY BECAUSE MANUALLY GO TO STEP EVALUATION BY AUDITOR AFTER OBJECTION COMMITTEE)
          return stepsObjectionManual;  //GBAT-81: Changed compared to GBAT-80, so we hide status Αξιολόγηση από Φορέα Υλοποίησης
      }
      else if(activeTaskName === 'task.name.temporary_rejected' || activeTaskName === 'task.name.application_evaluation_before_committee'){
        return stepsObjection;
      }else {
        return stepsBeneficiary;
      }
    }else if(isAuditor(user?.groups)){
      return stepsAuditor;
    }else if(isObjectionCommittee(user?.groups)){
      return stepsObjectionEvaluation;
    }
    else{
      return null;
    }
  }
  },[activeTaskName, user]);

  //Set current step based on user and Status
  useEffect(() => {
    if (!steps) return;

    if (isBeneficiary(user?.groups)) {
      if (activeTaskName === 'task.name.temporary_rejected') {
        setCurrent(4); //Tab Ένσταση
      } 
    } else if (isAuditor(user?.groups)) {
      if (activeTaskName === 'task.name.application_evaluation_by_auditor'){
        setCurrent(3); //Tab Αξιολόγηση από Φορέα Υλοποίησης
      }
    } else if (isObjectionCommittee(user?.groups)) {
       if (activeTaskName === 'task.name.application_evaluation_by_committee'){
        setCurrent(5); //Tab Αξιολόγηση ΕΕ
      }
    } else {
      setCurrent(0);
    }
  }, [activeTaskName, user, steps]);

  return (
    loadingPageVar ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">
    {(!viewMode && isAuditor(user?.groups) && (activeTaskName === 'task.name.application_evaluation')) &&
      <Modal
        isVisible={!consent}
        // isVisible={false}
        Icon ={WarningBlue}
        width={400}
        okText={'Επιβεβαίωση'}
        cancelText={'Ακύρωση'}
        handleCancel={() => {
          dispatch(submitConsent({ consent: false, taskId: params.taskId, navigate }));
        }}
        handleConfirm={() => {
          dispatch(submitConsent({ consent: true, taskId: params.taskId, navigate }));
        }}
      >
        <div className="modal-submit-content">
          <div className="content-title">Δήλωση Μη Σύγκρουσης Συμφερόντων</div>
          <div className="content-paragraph">
          Με ατομική μου ευθύνη και γνωρίζοντας τις κυρώσεις που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου 22 του Ν. 1599/1986, δηλώνω ότι δεν τίθεται θέμα σύγκρουσης συμφερόντων με το Φορέα της Επένδυσης.
           <br />
            <div className="mt-1">
            Σε περίπτωση σύγκρουσης συμφερόντων οδηγήστε την αίτηση σε νέο Ανεξάρτητο Αξιολογητή. 
            </div>
          </div>
        </div>
      </Modal>
    }

      {(!viewMode && isObjectionCommittee(user?.groups) && (activeTaskName === 'task.name.application_evaluation_before_committee')) &&
      <Modal
        isVisible={!consentByCommittee}
        // isVisible={false}
        Icon ={WarningBlue}
        width={400}
        okText={'Επιβεβαίωση'}
        cancelText={'Ακύρωση'}
        handleCancel={() => {
          dispatch(submitConsent({ consent: false, taskId: params.taskId, navigate }));
        }}
        handleConfirm={() => {
          dispatch(submitConsent({ consent: true, taskId: params.taskId, navigate }));
        }}
      >
        <div className="modal-submit-content">
          <div className="content-title">Δήλωση Μη Σύγκρουσης Συμφερόντων</div>
          <div className="content-paragraph">
          Με ατομική μου ευθύνη και γνωρίζοντας τις κυρώσεις που προβλέπονται από τις διατάξεις της παρ. 6 του άρθρου 22 του Ν. 1599/1986, δηλώνω ότι δεν τίθεται θέμα σύγκρουσης συμφερόντων με το Φορέα της Επένδυσης.
           <br />
            <div className="mt-1">
            Σε περίπτωση σύγκρουσης συμφερόντων οδηγήστε την αίτηση σε νέο Ανεξάρτητο Αξιολογητή. 
            </div>
          </div>
        </div>
      </Modal>
      }

     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      {carrier?.rejectReasons?.isSubmitValid === false &&
        <ValidationBanner 
          rejectReasons={carrier?.rejectReasons}
        />
      }
      <TabsTimeline 
          tabs={steps}
          current={current} 
          setCurrent={setCurrent} 
          customClass={`custom-tabs-timeline active-tab-${current+1}`}
      />
      <FormFooter 
          tabs={steps}
          current={current} 
          setCurrent={setCurrent} 
          currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default MainForm;